(function AgentVirtualEventsView($, Adzuki)
{
	"use strict";

	var $modal           = $('.modal'),
	    day_header_class = '',
	    day_class        = '';

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/AgentVirtualEvents/view/', function onload() {
			$('.speaker-bio-detail').click(function _showBio(e) {
				e.preventDefault();

				$(".modal-dialog").addClass('modal-lg');

				$modal.find('.modal-title').text($(this).data('name'));
				$modal.find('.modal-body').html($(this).data('bio'));

				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});

			$('.days').on('click', '.day-toggle', function dayToggleClicked() {
				day_header_class = '.day-header-' + $(this).data('day');
				day_class        = '.day-' + $(this).data('day');

				if ($(this).hasClass(Adzuki.FaIcon.getIconStyleName('collapse'))) {
					$(day_class).addClass('hidden');
					$(day_header_class).addClass('round-corners');

					$(this).removeClass(Adzuki.FaIcon.getIconStyle('collapse', 'regular'));
					$(this).addClass(Adzuki.FaIcon.getIconStyle('expand', 'regular'));
				} else {
					$(day_class).removeClass('hidden');
					$(day_header_class).removeClass('round-corners');

					$(this).removeClass(Adzuki.FaIcon.getIconStyle('expand', 'regular'));
					$(this).addClass(Adzuki.FaIcon.getIconStyle('collapse', 'regular'));
				}
			});

			$('.speaker-click').click(function _unhideSections() {
				var session_id = $(this).data('session-id');

				$('a[name="session-' + session_id + '"]').parents('div.days').find('i.day-toggle').click();
			});
		});
	});
}(jQuery, window.Adzuki || {}));